import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['MeasurementDevice'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getMeasurementDeviceById: build.query<GetMeasurementDeviceByIdApiResponse, GetMeasurementDeviceByIdApiArg>({
        query: (queryArg) => ({ url: `/MeasurementDevice/${queryArg}` }),
        providesTags: ['MeasurementDevice'],
      }),
      deleteMeasurementDeviceById: build.mutation<
        DeleteMeasurementDeviceByIdApiResponse,
        DeleteMeasurementDeviceByIdApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementDevice/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['MeasurementDevice'],
      }),
      getMeasurementDeviceGetAll: build.query<GetMeasurementDeviceGetAllApiResponse, GetMeasurementDeviceGetAllApiArg>({
        query: () => ({ url: `/MeasurementDevice/get-all` }),
        providesTags: ['MeasurementDevice'],
      }),
      getMeasurementDeviceGetAllByMeasurementPoint: build.query<
        GetMeasurementDeviceGetAllByMeasurementPointApiResponse,
        GetMeasurementDeviceGetAllByMeasurementPointApiArg
      >({
        query: (queryArg) => ({
          url: `/MeasurementDevice/get-all-by-measurement-point`,
          params: {
            measurementPointId: queryArg,
          },
        }),
        providesTags: ['MeasurementDevice'],
      }),
      getMeasurementDeviceByIdHasDataForCurrentVersion: build.query<
        GetMeasurementDeviceByIdHasDataForCurrentVersionApiResponse,
        GetMeasurementDeviceByIdHasDataForCurrentVersionApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementDevice/${queryArg}/has-data-for-current-version` }),
        providesTags: ['MeasurementDevice'],
      }),
      getMeasurementDeviceByIdHasData: build.query<
        GetMeasurementDeviceByIdHasDataApiResponse,
        GetMeasurementDeviceByIdHasDataApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementDevice/${queryArg}/has-data` }),
        providesTags: ['MeasurementDevice'],
      }),
      getMeasurementDeviceGetPastVersionsByTechnicalName: build.query<
        GetMeasurementDeviceGetPastVersionsByTechnicalNameApiResponse,
        GetMeasurementDeviceGetPastVersionsByTechnicalNameApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementDevice/get-past-versions/${queryArg}` }),
        providesTags: ['MeasurementDevice'],
      }),
      postMeasurementDeviceNewVersionByMeasurementDeviceTechnicalName: build.mutation<
        PostMeasurementDeviceNewVersionByMeasurementDeviceTechnicalNameApiResponse,
        PostMeasurementDeviceNewVersionByMeasurementDeviceTechnicalNameApiArg
      >({
        query: (queryArg) => ({ url: `/MeasurementDevice/new-version/${queryArg}`, method: 'POST' }),
        invalidatesTags: ['MeasurementDevice'],
      }),
      postMeasurementDevice: build.mutation<PostMeasurementDeviceApiResponse, PostMeasurementDeviceApiArg>({
        query: (queryArg) => ({ url: `/MeasurementDevice`, method: 'POST', body: queryArg }),
        invalidatesTags: ['MeasurementDevice'],
      }),
      putMeasurementDevice: build.mutation<PutMeasurementDeviceApiResponse, PutMeasurementDeviceApiArg>({
        query: (queryArg) => ({ url: `/MeasurementDevice`, method: 'PUT', body: queryArg }),
        invalidatesTags: ['MeasurementDevice'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as measurementDeviceApi };
export type GetMeasurementDeviceByIdApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementDeviceExternalDto;
export type GetMeasurementDeviceByIdApiArg = number;
export type DeleteMeasurementDeviceByIdApiResponse = unknown;
export type DeleteMeasurementDeviceByIdApiArg = number;
export type GetMeasurementDeviceGetAllApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementDeviceExternalDto;
export type GetMeasurementDeviceGetAllApiArg = void;
export type GetMeasurementDeviceGetAllByMeasurementPointApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementDeviceExternalDto;
export type GetMeasurementDeviceGetAllByMeasurementPointApiArg = /** Optional id of the measurement point */
  | number
  | undefined;
export type GetMeasurementDeviceByIdHasDataForCurrentVersionApiResponse = /** status 200 OK */ boolean;
export type GetMeasurementDeviceByIdHasDataForCurrentVersionApiArg = /** Measurement device ID */ number;
export type GetMeasurementDeviceByIdHasDataApiResponse = /** status 200 OK */ boolean;
export type GetMeasurementDeviceByIdHasDataApiArg = /** Measurement device ID */ number;
export type GetMeasurementDeviceGetPastVersionsByTechnicalNameApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementDeviceVersionExternalDto;
export type GetMeasurementDeviceGetPastVersionsByTechnicalNameApiArg =
  /** Technical name of the measurement point */ string;
export type PostMeasurementDeviceNewVersionByMeasurementDeviceTechnicalNameApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementDeviceVersionExternalDto;
export type PostMeasurementDeviceNewVersionByMeasurementDeviceTechnicalNameApiArg =
  /** Technical name of the measurement device */ string;
export type PostMeasurementDeviceApiResponse =
  /** status 200 OK */ ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementDeviceExternalDto;
export type PostMeasurementDeviceApiArg =
  ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoMeasurementDeviceExternalDto;
export type PutMeasurementDeviceApiResponse = unknown;
export type PutMeasurementDeviceApiArg =
  ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoMeasurementDeviceExternalDto;
export type ApiCommonExternalDtoMeasurementDeviceExternalDto = {
  id?: number;
  tsoId?: number;
  name: string;
  technicalName: string;
  manufacturingYear?: number | null;
  activeFrom: string;
  activeTo?: string | null;
  comment: string;
  measurementDeviceModelId: number;
  measurementPointId: number;
  isUsedForCorrelationCalculation: boolean;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementDeviceExternalDto = {
  externalDto?: ApiCommonExternalDtoMeasurementDeviceExternalDto;
  externalDtos?: ApiCommonExternalDtoMeasurementDeviceExternalDto[] | null;
};
export type ApiCommonExternalDtoMeasurementDeviceVersionExternalDto = {
  id?: number;
  tsoId?: number;
  name: string;
  technicalName: string;
  manufacturingYear?: number | null;
  activeFrom: string;
  activeTo?: string | null;
  comment: string;
  measurementDeviceModelId: number;
  measurementDeviceId: number;
  measurementPointId: number;
};
export type ApiCommonResponsesBaseCrudResponse601ApiCommonExternalDtoMeasurementDeviceVersionExternalDto = {
  externalDto?: ApiCommonExternalDtoMeasurementDeviceVersionExternalDto;
  externalDtos?: ApiCommonExternalDtoMeasurementDeviceVersionExternalDto[] | null;
};
export type ApiCommonRequestsBaseCrudRequest601ApiCommonExternalDtoMeasurementDeviceExternalDto = {
  externalDto?: ApiCommonExternalDtoMeasurementDeviceExternalDto;
};
export const {
  useGetMeasurementDeviceByIdQuery,
  useLazyGetMeasurementDeviceByIdQuery,
  useDeleteMeasurementDeviceByIdMutation,
  useGetMeasurementDeviceGetAllQuery,
  useLazyGetMeasurementDeviceGetAllQuery,
  useGetMeasurementDeviceGetAllByMeasurementPointQuery,
  useLazyGetMeasurementDeviceGetAllByMeasurementPointQuery,
  useGetMeasurementDeviceByIdHasDataForCurrentVersionQuery,
  useLazyGetMeasurementDeviceByIdHasDataForCurrentVersionQuery,
  useGetMeasurementDeviceByIdHasDataQuery,
  useLazyGetMeasurementDeviceByIdHasDataQuery,
  useGetMeasurementDeviceGetPastVersionsByTechnicalNameQuery,
  useLazyGetMeasurementDeviceGetPastVersionsByTechnicalNameQuery,
  usePostMeasurementDeviceNewVersionByMeasurementDeviceTechnicalNameMutation,
  usePostMeasurementDeviceMutation,
  usePutMeasurementDeviceMutation,
} = injectedRtkApi;
